// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { copy16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-copy': IconCopy;
    }
}

/**
 * The icon component for the 'copy' icon
 */
export class IconCopy extends IconSvg {
    public constructor() {
        super(copy16X16);
    }
}

registerIconSvg('icon-copy', IconCopy);
export const iconCopyTag = 'nimble-icon-copy';
